<template>
  <div
    v-if="policyPath"
    class="agreement"
    v-bind="$attrs">
    <div class="agreement-body">
      <BaseCheckbox :checked="modelValue" @change="onChangeCheckbox" />
      <div class="agreement-link">
        <i18n-t
          keypath="agreement"
          scope="global"
          tag="p"
          class="text-14-400">
          <template #link>
            <LocLink
              :to="policyPath"
              target="_blank"
              class="text-14-400">
              {{ $t("agreement_link") }}
            </LocLink>
          </template>
        </i18n-t>
      </div>
    </div>
    <div v-if="error" class="agreement-error">
      <transition name="input_error">
        <span class="input-error__text"> {{ error }} </span>
      </transition>
    </div>
  </div>
</template>

<script lang="ts">
import { PropType } from "vue";
import BaseCheckbox from "~/components/input/BaseCheckbox.vue";
import LocLink from "~/components/lang/LocLink.vue";

export default {
  components: { LocLink, BaseCheckbox },
  props: {
    modelValue: {
      type: Boolean as PropType<boolean>,
      required: true,
    },
    error: {
      type: String as PropType<string | null | undefined>,
      default: null,
    },
  },
  emits: ["update:modelValue"],
  setup(props, { emit }) {
    const policyPath = "/processing-personal-data";

    function onChangeCheckbox() {
      emit("update:modelValue", !props.modelValue);
    }

    return {
      onChangeCheckbox,
      policyPath,
    };
  },
};
</script>
